
export const Roles: any[] = [
  { label: 'SuperAdmin', value: '1', aliase: 'SA' },
  { label: 'Faculty', value: '2', aliase: 'FC' },
  { label: 'Client', value: '3', aliase: 'CL' },
  { label: 'Student', value: '4', aliase: 'STD' },
  { label: 'Admin', value: '5', aliase: 'AD' },
  { label: 'HOD', value: '6', aliase: 'HOD' },
  { label: 'Teacher', value: '7', aliase: 'TCH' },
  { label: 'Parent', value: '8', aliase: 'PRNT' },
  { label: 'Staff', value: '10', aliase: 'STF' },
  { label: 'Parent', value: '9', aliase: 'PRNT' },
  { label: 'Accountant', value: '11', aliase: 'ACCT' },
  { label: 'Librarian', value: '12', aliase: 'LIB' },
  { label: 'Transport', value: '13', aliase: 'TRNS' },
  { label: 'Admin Staff', value: '14', aliase: 'ADSTF' },
];

export const permissionRoles = [
    { label: 'HOD', value: '6' },
    { label: 'Teacher', value: '7' },
    { label: 'Student', value: '4' },
    { label: 'Staff', value: '10' },
  ];
export const dashboard_messages: any[] = [
  {
    message: 'Your admission has been confirmed. Welcome to XYZ Institute!',
    class: '6th A',
    sender_name: 'Admin',
    sender_image: 'https://images.unsplash.com/flagged/photo-1570612861542-284f4c12e75f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    date: '2025-03-08 10:30 AM',
    type: 'SMS'
  },
  {
    message: 'Reminder: Your fee payment is due on March 15. Please clear it before the deadline.',
    class: '10th B',
    sender_name: 'Accounts Department',
    sender_image: 'https://images.unsplash.com/photo-1545167622-3a6ac756afa4?q=80&w=2024&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    date: '2025-03-07 05:00 PM',
    type: 'email'
  },
  {
    message: 'Tomorrow is a holiday due to maintenance. Stay home and stay safe!',
    class: 'All Classes',
    sender_name: 'Principal',
    sender_image: null,
    date: '2025-03-06 08:00 AM',
    type: 'notification'
  },
  {
    message: 'New timetable has been uploaded on the portal. Please check your class schedule.',
    class: '8th C',
    sender_name: 'Academics',
    sender_image: null,
    date: '2025-03-05 02:45 PM',
    type: 'email'
  },
  {
    message: 'Your library book is due for return tomorrow. Avoid late fees by returning it on time.',
    class: '9th A',
    sender_name: 'Library',
    sender_image: 'https://images.unsplash.com/photo-1545696968-1a5245650b36?q=80&w=2032&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    date: '2025-03-04 11:20 AM',
    type: 'SMS'
  },
  {
    message: 'Workshop on AI & ML is scheduled for next Monday. Register now!',
    class: '11th Science',
    sender_name: 'Event Coordinator',
    sender_image: null,
    date: '2025-03-03 03:15 PM',
    type: 'notification'
  }
];

export const departments: any[] = [

  {
    "department_name": "External Students",
    "hod": "-",
    "no_of_classes": "-",
  },
  {
    "department_name": "Independent Teachers",
    "hod": "-",
    "no_of_classes": "-",
  },
  {
    "department_name": "Department A",
    "hod": "Prajakta Bhavsar",
    "no_of_classes": 5,
  },
  {
    "department_name": "Department B",
    "hod": "Prajakta Bhavsar",
    "no_of_classes": 5,
  },
  {
    "department_name": "Department C",
    "hod": "Rahul Sharma",
    "no_of_classes": 3,
  },
  {
    "department_name": "Department D",
    "hod": "Sneha Patil",
    "no_of_classes": 7,
  },
  {
    "department_name": "Department E",
    "hod": "Amit Verma",
    "no_of_classes": 6,
  },
  {
    "department_name": "Department F",
    "hod": "Ritika Singh",
    "no_of_classes": 4,
  },
  {
    "department_name": "Department G",
    "hod": "Kunal Desai",
    "no_of_classes": 2,
  },
  {
    "department_name": "Department H",
    "hod": "Meera Iyer",
    "no_of_classes": 8,
  }
]

export const departmentsPerformance: any[] = [
  {
    "student_name": "Prajakta Bhavsar",
    "overall": "50%",
    "videos": "50%",
    "flashcard": "60%",
    "ai_test": "40%"
  },
  {
    "student_name": "Rohan Sharma",
    "overall": "75%",
    "videos": "80%",
    "flashcard": "70%",
    "ai_test": "60%"
  },
  {
    "student_name": "Aditi Verma",
    "overall": "65%",
    "videos": "60%",
    "flashcard": "75%",
    "ai_test": "50%"
  },
  {
    "student_name": "Kunal Deshmukh",
    "overall": "55%",
    "videos": "50%",
    "flashcard": "65%",
    "ai_test": "45%"
  },
  {
    "student_name": "Sneha Iyer",
    "overall": "85%",
    "videos": "90%",
    "flashcard": "80%",
    "ai_test": "70%"
  },
  {
    "student_name": "Vikas Joshi",
    "overall": "45%",
    "videos": "40%",
    "flashcard": "50%",
    "ai_test": "35%"
  },
  {
    "student_name": "Neha Patel",
    "overall": "72%",
    "videos": "70%",
    "flashcard": "75%",
    "ai_test": "65%"
  },
  {
    "student_name": "Amit Tiwari",
    "overall": "60%",
    "videos": "55%",
    "flashcard": "70%",
    "ai_test": "50%"
  },
  {
    "student_name": "Pooja Shah",
    "overall": "80%",
    "videos": "85%",
    "flashcard": "78%",
    "ai_test": "72%"
  },
  {
    "student_name": "Rajesh Kumar",
    "overall": "68%",
    "videos": "65%",
    "flashcard": "70%",
    "ai_test": "58%"
  }
]


export const courses: any[] = [
  {
    "title": "Web Development",
    'is_active': true,
    "img": "data:image/png;base64,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",
    "type": "Video Course"
  },
  {
    "title": "AI & Machine Learning",
    'is_active': true,
    "img": "data:image/jpeg;base64,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",
    "type": "Flashcard"
  },
  {
    "title": "Cyber Security",
    'is_active': true,
    "img": "data:image/jpeg;base64,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",
    "type": "Test Series"
  },
  {
    "title": "Cloud Computing",
    'is_active': false,
    "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkA294oUZ8o7HaKcn5fjTXsN6vG642Nk3WQg&s",
    "type": "Conclave"
  },
  {
    "title": "Blockchain Technology",
    'is_active': false,
    "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDBLkeUldLtW4YsQk2fmrblf0Go9gSaCw0lw&s",
    "type": "Video Course"
  },
  {
    "title": "Data Science",
    'is_active': false,
    "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxpyGROWM_dMjCQNATojlThbkLxGv7_14ifA&shttps://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTn-n-X1Ye61cCYsEjhckCVq84kWV0MPx62Jw&s",
    "type": "Flashcard"
  },
  {
    "title": "Mobile App Development",
    'is_active': false,
    "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_P7_d7jLmitZmAmTIu4LZsN33b1Mps8X_Gg&s",
    "type": "Test Series"
  },
  {
    "title": "Software Engineering",
    'is_active': false,
    "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGsjmPUUegaW-eC5p2xmbPPkWLF14TifsMxQ&s",
    "type": "Conclave"
  },
  {
    "title": "Internet of Things",
    'is_active': false,
    "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb1tirqvt_WiEUMN6jdL5D2ksqcash9IP15Q&s",
    "type": "Video Course"
  },
  {
    "title": "DevOps & Automation",
    'is_active': false,
    "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLwPpIlAl4m4peA9GvAgI4m80MNwM4nQm-Mg&s",
    "type": "Flashcard"
  }
]

export const courseStructureData = [
  {
    "category": "Happy",
    "items": [
      {
        "title": "Monogram",
        "price": "₹10",
        "views": 5,
        "reel": "No",
        "image": "https://plus.unsplash.com/premium_photo-1681412205359-a803b2649d57?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxfHx8ZW58MHx8fHx8"
      },
      {
        "title": "Calligraphy",
        "price": "₹15",
        "views": 8,
        "reel": "Yes",
        "image": "https://plus.unsplash.com/premium_photo-1738503913362-61ad1fa58f90?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHw5fHx8ZW58MHx8fHx8"
      },
      {
        "title": "Illustration Art",
        "price": "₹12",
        "views": 4,
        "reel": "No",
        "image": "https://images.unsplash.com/photo-1742506261388-4f5a6857d6c4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMnx8fGVufDB8fHx8fA%3D%3D"
      }
    ]
  },
  {
    "category": "Sad",
    "items": [
      {
        "title": "Abstract Art",
        "price": "₹20",
        "views": 7,
        "reel": "Yes",
        "image": "https://images.unsplash.com/photo-1741705877367-94b1f8b39db1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwyMHx8fGVufDB8fHx8fA%3D%3D"
      },
      {
        "title": "Oil Painting",
        "price": "₹25",
        "views": 10,
        "reel": "No",
        "image": "https://images.unsplash.com/photo-1742240483286-5fc6884638a1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwyN3x8fGVufDB8fHx8fA%3D%3D"
      }
    ]
  },
  {
    "category": "Gen-Geno",
    "items": [
      {
        "title": "3D Animation",
        "price": "₹30",
        "views": 12,
        "reel": "Yes",
        "image": "https://images.unsplash.com/photo-1743041095820-3e09632071e1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwzNXx8fGVufDB8fHx8fA%3D%3D"
      },
      {
        "title": "Sketching",
        "price": "₹18",
        "views": 6,
        "reel": "No",
        "image": "https://images.unsplash.com/photo-1743020006589-731079b61c1b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHw1N3x8fGVufDB8fHx8fA%3D%3D"
      },
      {
        "title": "Watercolor",
        "price": "₹22",
        "views": 9,
        "reel": "Yes",
        "image": "https://images.unsplash.com/photo-1742228896964-83f6327740ea?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHw2M3x8fGVufDB8fHx8fA%3D%3D"
      }
    ]
  },
  {
    "category": "Vert",
    "items": [
      {
        "title": "Typography Design",
        "price": "₹28",
        "views": 14,
        "reel": "Yes",
        "image": "https://plus.unsplash.com/premium_photo-1742945845688-7c11c2f6d33d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHw3NHx8fGVufDB8fHx8fA%3D%3D"
      }
    ]
  },
  {
    "category": "Termi",
    "items": [
      {
        "title": "Handmade Crafts",
        "price": "₹35",
        "views": 11,
        "reel": "No",
        "image": "https://images.unsplash.com/photo-1741851374467-c53876940807?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHw4OXx8fGVufDB8fHx8fA%3D%3D"
      },
      {
        "title": "Poster Design",
        "price": "₹40",
        "views": 16,
        "reel": "Yes",
        "image": "https://images.unsplash.com/photo-1742197062761-1e44b0d7fd2e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHw5NXx8fGVufDB8fHx8fA%3D%3D"
      }
    ]
  },
  {
    "category": "Bio",
    "items": [
      {
        "title": "Scientific Illustration",
        "price": "₹50",
        "views": 20,
        "reel": "No",
        "image": "https://images.unsplash.com/photo-1742144897654-5fb5b98dd73e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHw5N3x8fGVufDB8fHx8fA%3D%3D"
      },
      {
        "title": "Medical Diagrams",
        "price": "₹55",
        "views": 18,
        "reel": "Yes",
        "image": "https://images.unsplash.com/photo-1742829705753-f07509bc88ac?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMDV8fHxlbnwwfHx8fHw%3D"
      },
      {
        "title": "Biotech Infographics",
        "price": "₹60",
        "views": 22,
        "reel": "No",
        "image": "https://images.unsplash.com/photo-1742855751015-5bda25456249?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwxMjF8fHxlbnwwfHx8fHw%3D"
      }
    ]
  }
]

export const rankedStudent = [
  { "rank": 1, "name": "Anand Sharma", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" },
  { "rank": 2, "name": "Priya Kapoor", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { "rank": 3, "name": "Sneha Mehta", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { "rank": 4, "name": "Anand Sharma", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" },
  { "rank": 5, "name": "Priya Kapoor", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { "rank": 6, "name": "Sneha Mehta", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/1065084/pexels-photo-1065084.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { "rank": 7, "name": "Rohan Das", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { "rank": 8, "name": "Megha Singh", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { "rank": 9, "name": "Tanya Joshi", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/1181690/pexels-photo-1181690.jpeg?auto=compress&cs=tinysrgb&w=600" },
  { "rank": 10, "name": "Karan Verma", "class": "9ᵗʰ (A)", "image": "https://images.pexels.com/photos/18935827/pexels-photo-18935827/free-photo-of-smiling-man-in-eyeglasses.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load" }
]

export const comments = [
  {
    "id": 1,
    "name": "Ms. Radhika Verma",
    "img": '',
    "date": "2025-01-05",
    "time": "09:30 AM",
    "message": "Students are encouraged to complete the essay on 'Global Warming and Its Effects' by next Monday. This will help develop critical thinking and writing skills essential for academic progress.",
    "recipient": "8ᵗʰ (B)"
  },
  {
    "id": 2,
    "name": "Mr. Arjun Mehta",
    "img": '',
    "date": "2025-01-05",
    "time": "10:15 AM",
    "message": "Reminder: All students must bring their geometry kits for tomorrow’s practical. We will be starting with basic constructions using compass and ruler.",
    "recipient": "6ᵗʰ (A)"
  },
  {
    "id": 3,
    "name": "Mrs. Swati Kulkarni",
    "img": '',
    "date": "2025-01-05",
    "time": "11:45 AM",
    "message": "Congratulations to all participants of the inter-school debate competition. Your confidence and clarity of thought were commendable. Keep striving for excellence!",
    "recipient": "All"
  },
  {
    "id": 4,
    "name": "Mr. Ravi Sharma",
    "img": '',
    "date": "2025-01-05",
    "time": "12:00 PM",
    "message": "Please review the recorded session on Algebraic Equations before the next class. It will help you understand quadratic solutions more efficiently.",
    "recipient": "7ᵗʰ (A)"
  },
  {
    "id": 5,
    "name": "Ms. Neha Singh",
    "img": '',
    "date": "2025-01-05",
    "time": "01:00 PM",
    "message": "Field trip consent forms must be submitted by Wednesday. No student will be allowed without prior written approval from parents or guardians.",
    "recipient": "All"
  },
  {
    "id": 6,
    "name": "Mr. Anil D’Souza",
    "img": '',
    "date": "2025-01-05",
    "time": "01:30 PM",
    "message": "Your enthusiasm during the Science Exhibition was truly inspiring. Special thanks to the volunteers and participants who made it a great success!",
    "recipient": "9ᵗʰ (C)"
  },
  {
    "id": 7,
    "name": "Ms. Shalini Nair",
    "img": '',
    "date": "2025-01-06",
    "time": "09:00 AM",
    "message": "The final math test will cover chapters 6 through 10. Ensure that all exercises from the textbook are revised and doubts are cleared in advance.",
    "recipient": "6ᵗʰ (A)"
  },
  {
    "id": 8,
    "name": "Mr. Kunal Desai",
    "img": '',
    "date": "2025-01-06",
    "time": "10:10 AM",
    "message": "We will be organizing a special workshop on time management and study techniques this Friday. Attendance is optional but highly recommended.",
    "recipient": "7ᵗʰ (B)"
  },
  {
    "id": 9,
    "name": "Mrs. Pooja Bhatt",
    "img": '',
    "date": "2025-01-06",
    "time": "11:30 AM",
    "message": "All students who missed the Biology test should report to Lab 3 on Thursday at 10:00 AM for a retest. Bring all necessary materials.",
    "recipient": "8ᵗʰ (A)"
  },
  {
    "id": 10,
    "name": "Mr. Aditya Chauhan",
    "img": '',
    "date": "2025-01-06",
    "time": "01:15 PM",
    "message": "Please maintain silence in the library. Continued disruptions may lead to suspension of access privileges. Let’s respect the learning environment.",
    "recipient": "All"
  },
  {
    "id": 11,
    "name": "Mrs. Anuja Pandey",
    "img": '',
    "date": "2025-01-06",
    "time": "02:45 PM",
    "message": "Creative writing notebooks will be collected on Friday. Ensure your stories are complete and edited for grammar and spelling mistakes.",
    "recipient": "7ᵗʰ (A)"
  },
  {
    "id": 12,
    "name": "Mr. Nishant Kapoor",
    "img": '',
    "date": "2025-01-07",
    "time": "08:50 AM",
    "message": "Parents-Teacher meetings for Class 9 will be held on 12th January. Slots will be allotted on a first-come, first-served basis.",
    "recipient": "9ᵗʰ (A)"
  }
]

export const calendarConfig = {
  lecture: {
    colorName: 'Lecture',
    lightColors: {
      main: '#f9d71c',
      container: '#fff5aa',
      onContainer: '#594800',
    },
  },
  seminar: {
    colorName: 'Seminar',
    lightColors: {
      main: '#f91c45',
      container: '#ffd2dc',
      onContainer: '#59000d',
    },
  },
  workshop: {
    colorName: 'Workshop',
    lightColors: {
      main: '#1cf9b0',
      container: '#dafff0',
      onContainer: '#004d3d',
    },
  },
  guest_lecture: {
    colorName: 'Guest Lecture',
    lightColors: {
      main: '#1c7df9',
      container: '#d2e7ff',
      onContainer: '#002859',
    },
  },
  fest: {
    colorName: 'Fest',
    lightColors: {
      main: '#9c27b0',
      container: '#f3e5f5',
      onContainer: '#4a0072',
    },
  },
  webinar: {
    colorName: 'Webinar',
    lightColors: {
      main: '#03a9f4',
      container: '#e1f5fe',
      onContainer: '#01579b',
    },
  },
  hackathon: {
    colorName: 'Hackathon',
    lightColors: {
      main: '#ff9800',
      container: '#fff3e0',
      onContainer: '#e65100',
    },
  },
  cultural_event: {
    colorName: 'Cultural Event',
    lightColors: {
      main: '#e91e63',
      container: '#fce4ec',
      onContainer: '#880e4f',
    },
  },
  sports: {
    colorName: 'Sports',
    lightColors: {
      main: '#4caf50',
      container: '#e8f5e9',
      onContainer: '#1b5e20',
    },
  },
  competition: {
    colorName: 'Competition',
    lightColors: {
      main: '#ff5722',
      container: '#fbe9e7',
      onContainer: '#bf360c',
    },
  },
  orientation: {
    colorName: 'Orientation',
    lightColors: {
      main: '#3f51b5',
      container: '#e8eaf6',
      onContainer: '#1a237e',
    },
  },
  alumni_meet: {
    colorName: 'Alumni Meet',
    lightColors: {
      main: '#009688',
      container: '#e0f2f1',
      onContainer: '#004d40',
    },
  },
}

export const calendarEvents = [
  {
    id: '1',
    title: 'Introduction to Angular - Guest Lecture',
    start: '2025-07-11 10:00',
    end: '2025-07-11 12:00',
    calendarId: 'guest_lecture',
    description: 'Join us for a virtual introduction to Angular, a powerful framework for building dynamic and interactive web applications.',
  },
  {
    id: '2',
    title: 'Frontend Frameworks Seminar',
    start: '2025-07-12 14:00',
    end: '2025-07-12 16:00',
    calendarId: 'seminar',
    people: ['John Doe', 'Jane Smith', 'Bob Johnson'],
    location: 'Online',
  },
  {
    id: '3',
    title: 'Campus Cultural Fest',
    start: '2025-07-13 09:00',
    end: '2025-07-13 17:00',
    calendarId: 'fest',
  },
  {
    id: '4',
    title: 'Javascript Workshop',
    start: '2025-07-14 11:00',
    end: '2025-07-14 15:00',
    calendarId: 'workshop',
  },
  {
    id: '5',
    title: 'Weekly Lecture - Algorithms',
    start: '2025-07-15 08:00',
    end: '2025-07-15 10:00',
    calendarId: 'lecture',
  },
  {
    id: '6',
    title: 'Webinar: Career in AI',
    start: '2025-07-15 18:00',
    end: '2025-07-15 19:30',
    calendarId: 'webinar',
    rrule: 'FREQ=DAILY;COUNT=10;BYDAY=MO,TU,WE,TH,FR',
  },
  {
    id: '7',
    title: 'Annual Sports Day',
    start: '2025-07-16 08:00',
    end: '2025-07-16 14:00',
    calendarId: 'sports',
  },
  {
    id: '8',
    title: 'Hackathon Kickoff',
    start: '2025-07-17 10:00',
    end: '2025-07-18 11:00',
    calendarId: 'hackathon',
  },
  {
    id: '9',
    title: 'Dance and Drama Night',
    start: '2025-07-18 18:00',
    end: '2025-07-18 21:00',
    calendarId: 'cultural_event',
  },
  {
    id: '10',
    title: 'Coding Competition Finals',
    start: '2025-07-19 13:00',
    end: '2025-07-19 17:00',
    calendarId: 'competition',
  },
  {
    id: '11',
    title: 'Student Orientation',
    start: '2025-07-20 09:00',
    end: '2025-07-20 12:00',
    calendarId: 'orientation',
  },
  {
    id: '12',
    title: 'Alumni Networking Meet',
    start: '2025-07-21 16:00',
    end: '2025-07-21 18:00',
    calendarId: 'alumni_meet',
  },
  {
    id: '13',
    title: 'Math Lecture Series',
    start: '2025-07-22 10:00',
    end: '2025-07-22 12:00',
    calendarId: 'lecture',
  },
  {
    id: '14',
    title: 'Cloud Computing Seminar',
    start: '2025-07-23 14:00',
    end: '2025-07-23 16:00',
    calendarId: 'seminar',
  },
  {
    id: '15',
    title: 'ReactJS Workshop',
    start: '2025-07-24 11:00',
    end: '2025-07-24 14:00',
    calendarId: 'workshop',
  },
];




